import SectionHeading from "@/components/base/SectionHeading";
import { analysis } from "@/mocks/home";

export default function AnalysisSection() {
  return (
    <section id="analysis" className="w-full bg-secondary-100 py-14 md:py-20">
      <div className="mx-auto w-full px-4 md:px-6">
        <SectionHeading
          eyebrow="剧情解析"
          title="黑料短剧剧情解析与伏笔拆解"
          desc="从镜头细节到人物动机，把容易被快进带过的信息重新拎出来，看看哪些线索其实早就出现过。"
        />

        <div className="mt-10 grid grid-cols-1 gap-6 lg:grid-cols-3">
          {analysis.map((item, index) => (
            <article
              key={item.title}
              className={`overflow-hidden rounded-lg border border-background-200 bg-background-50 ${
                index === 0 ? "lg:col-span-2" : ""
              }`}
            >
              <div className={`w-full overflow-hidden ${index === 0 ? "h-56 md:h-72" : "h-48"}`}>
                <img
                  src={item.image}
                  alt={`黑料短剧剧情解析：${item.title}`}
                  title={`黑料短剧 剧情解析 ${item.category}`}
                  className="h-full w-full object-cover object-top"
                />
              </div>
              <div className="p-6">
                <div className="flex flex-wrap items-center gap-3">
                  <span className="rounded-full bg-accent-100 px-3 py-1 text-xs font-bold text-accent-700">
                    {item.category}
                  </span>
                  <span className="flex items-center gap-1 text-xs text-foreground-500">
                    <i className="ri-time-line"></i>
                    阅读约 {item.readTime}
                  </span>
                </div>
                <h3 className="mt-4 font-heading text-lg font-bold leading-snug text-foreground-950 md:text-xl">
                  {item.title}
                </h3>
                <p className="mt-3 text-sm leading-relaxed text-foreground-600">{item.excerpt}</p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}